// extracted by mini-css-extract-plugin
export var alpha = "_i2-4";
export var alphaInputContainer = "_i2-j";
export var badge = "_i2-b";
export var brandKitGrid = "_i2-l";
export var brandKitItem = "_i2-m";
export var brandKitSwatch = "_i2-n";
export var controls = "_i2-5";
export var formatDropdown = "_i2-h";
export var formatSelector = "_i2-g";
export var hex = "_i2-6";
export var hexInput = "_i2-i";
export var hue = "_i2-3";
export var hueAndAlphaPointer = "_i2-a";
export var percentageLabel = "_i2-k";
export var picker = "_i2-0";
export var rgba = "_i2-8";
export var rgbaSection = "_i2-7";
export var saturation = "_i2-1";
export var saturationPointer = "_i2-9";
export var sliders = "_i2-2";
export var swatch = "_i2-c";
export var swatchDisabled = "_i2-f";
export var swatchRing = "_i2-d";
export var swatchTransparent = "_i2-e";